import { render, staticRenderFns } from "./dialog-claim-input.vue?vue&type=template&id=bf41cd78&"
import script from "./dialog-claim-input.vue?vue&type=script&lang=js&"
export * from "./dialog-claim-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports